import { useRouter } from "next/router";
import Stepper from "react-stepper-horizontal";

export default function StepProgress(props) {
  const router = useRouter();
  const goToStep1Click = () => {
    if (props.step === 1) {
      router.back();
    }
  };
  return (
    <>
      <div style={{ marginTop: "-40px", marginBottom: "20px" }} className='stepper-container'>
        <Stepper
          activeColor="#101661"
          completeColor="#101661"
          defaultColor="#757575"
          defaultBarColor="#757575"
          completeBarColor="#101661"
          steps={[
            {
              title: "Application Information",
              onClick: (e) => goToStep1Click(e),
            },
            { title: "Application Submission" },
            { title: props.isLLCIncorporation ? "Get Your LLC" : "Receive EIN" },
          ]}
          activeStep={props.step}
        />

      </div>
    </>
  );
}
